import { useEffect, useState } from 'react';
import { toAbsoluteUrl } from '../../../assets/helpers/AssetHelpers';
import './jainamLoader.css';

const LOADER_MESSAGE_INTERVAL_MS = 2200;

export const loaderMessages = {
	article: [
		'Opening the right page for you…',
		'Good investors ask good questions. Hang tight!',
		'Patience pays, in markets and in loading screens.',
		'Reading the fine print so you don’t have to…',
		'Almost there. Your answer is on its way.',
	],
	faqs: [
		'Lining up the most helpful answers…',
		'Every expert was once a beginner. Loading your FAQs…',
		'Sorting questions so you find yours faster…',
		'Almost ready. Your questions are coming up.',
	],
	search: [
		'Searching every corner of our help centre…',
		'Hunting down the best matches for you…',
		'Great question! Finding the answers…',
		'Almost there. Your results are on the way.',
	],
};

type JainamLoaderProps = {
	variant?: 'page' | 'section' | 'inline';
	label?: string;
	messages?: string[];
};

const JainamLoader = ({ variant = 'page', label = 'Loading…', messages }: JainamLoaderProps) => {
	const [messageIndex, setMessageIndex] = useState(0);
	const hasMessages = variant !== 'inline' && !!messages?.length;

	useEffect(() => {
		if (!hasMessages) return;
		const timer = setInterval(
			() => setMessageIndex((index) => (index + 1) % messages!.length),
			LOADER_MESSAGE_INTERVAL_MS,
		);
		return () => clearInterval(timer);
	}, [hasMessages, messages]);

	if (variant === 'inline') {
		return <span className="jainam-loader-inline" role="status" aria-label={label} />;
	}

	return (
		<div className={`jainam-loader${variant === 'section' ? ' jainam-loader-section' : ''}`} role="status" aria-live="polite">
			<div className="jainam-loader-mark">
				<span className="jainam-loader-ring" aria-hidden="true" />
				<img src={toAbsoluteUrl('favicon/apple-icon.png')} alt="" className="jainam-loader-logo" />
			</div>
			<span key={hasMessages ? messageIndex : label} className="jainam-loader-label">
				{hasMessages ? messages![messageIndex] : label}
			</span>
		</div>
	);
};

export const BreadcrumbLoader = () => (
	<span className="jainam-loader-crumb" role="status" aria-label="Loading breadcrumb" />
);

export default JainamLoader;
